import { RaceStatus } from '@core/Areas/Racing/Types'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'

export const trackRacePreviewLoaded = () => trackKey(keys.racePreviewLoaded)
export const trackRacePreviewOpened = () => trackKey(keys.racePreviewOpened)
export const trackRacePreviewClosed = () => trackKey(keys.racePreviewClosed)

// for new layout
export type PreviewTipsEvent = {
  interaction_type: 'Bet Clicked' | 'Read More' | 'View Content'
  author?: string
  raceCode?: string
  meetingName?: string
  betType?: string
  raceStatus?: RaceStatus
}

export type PreviewTipsTrackerEvent = {
  interaction_type: PreviewTipsEvent['interaction_type']
} & Partial<Omit<PreviewTipsEvent, 'interaction_type'>>

const initValues: Omit<PreviewTipsEvent, 'interaction_type'> = {
  author: undefined,
  raceCode: undefined,
  meetingName: undefined,
  betType: undefined,
  raceStatus: undefined,
}

export const previewTipsTracker = (event: PreviewTipsTrackerEvent) => {
  trackEvent(keys.tipsPreviews, { ...initValues, ...event })
}
